import { createSlice } from "@reduxjs/toolkit";
import { requestOtp } from "./thunk";
export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true
    },
    reset_login_flag(state) {
      state.error = ""
      state.loading = false;
      state.errorMsg = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestOtp.pending, (state) => {
        state.loading = true;
        state.errorMsg = null;
      })
      .addCase(requestOtp.fulfilled, (state, action) => {
        console.log('action',action);
        state.user = action.payload;
        state.loading = false;
        state.errorMsg = false;
      })
      .addCase(requestOtp.rejected, (state, action) => {
        state.error = action.payload?.data || action.error?.message || "An unexpected error occurred.";
        state.loading = false;
        state.errorMsg = true;
    });
  }
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;